var emitter = require('../base/emitter'),
	common = require('../base/common');

function Loader(){

	var self = this;
	self.$loader = $('#loader');
	self.$frame1 = self.$loader.find('.frame1');
	self.$frame2 = self.$loader.find('.frame2');

	self.cache = [];

	emitter.on('loader:show', function(){

		self.show();

	})

	emitter.on('loader:load', function(){

		self.loadImages();

	})

	self.loadImages();

}

Loader.prototype.loadImages = function(){

	var self = this;

	common.$body.addClass('app-loading');
	self.$images = $('[data-load]');

	self.imagesCount = self.$images.length;
	self.loaded = 0;
	self.startLoad();

}

Loader.prototype.startLoad = function(){

	var self = this;

	$('body').addClass('is-loading');

	if(self.$images.length){
		self.$images.each(function(index, item){
			var image = new Image();
			if($(this).is('img'))
				var src = $(this).attr('src');
			else
				var src = $(this).css('background-image').slice(4, -1).replace(/["|']/g, "");
			if(
				($(this).hasClass('cover-low') && common.$window.width() >= 1024) || 
				($(this).hasClass('cover-high') && common.$window.width() < 1024) || 
				self.cache.indexOf(src) !== -1
			){
				self.loaded ++;
				self.loadedPerc = self.loaded / (self.imagesCount)
				self.setLoaded();
			}else{
				$(image).load(function(){
					self.loaded ++;
					self.loadedPerc = self.loaded / (self.imagesCount)
					self.setLoaded();
					self.cache.push(src);
				}).attr('src', src);
			}
		})
	}else{
		self.setLoaded();
	}

}

Loader.prototype.endLoad = function(){

	var self = this;
	self.$loader.addClass('loaded');
	emitter.emit('page:loaded');

	$('body').removeAttr('style');
	TweenLite.set(window, {scrollTo:{y: 0 }});

	TweenMax.to(self.$frame2, 0.3, { width: 0, ease: Power2.easeInOut })
	TweenMax.to(self.$frame1, 0.3, { width: 0, ease: Power2.easeInOut, delay: 0.2,onComplete: function(){

		self.$images = 0;
		$('body').removeClass('is-loading');
		common.$body.removeClass('app-loading');
		common.$window.trigger('scroll');
		self.hide();

	} })

}

Loader.prototype.setLoaded = function(){

	var self = this;

	TweenMax.to(self.$frame2, 0.5, { width: common.$window.width() * self.loadedPerc, ease: Power2.easeInOut, onComplete: function(){
		if(self.loaded == self.imagesCount){
			self.endLoad();
		}
	}})

}

Loader.prototype.show = function(){

	var self = this;
	TweenMax.set(self.$frame1, {width: 0});
	TweenMax.set(self.$frame2, {width: 0});
	TweenMax.to(self.$frame1, 0.3, { width: common.$window.width(), ease: Power2.easeInOut })
	self.$loader.show();

}

Loader.prototype.hide = function(){

	var self = this;
	self.$loader.hide();
	self.$loader.removeClass('loaded');

}

module.exports = Loader;


/** WEBPACK FOOTER **
 ** ./layouts/loader.js
 **/